// Configuration SEO avancée pour tous les jeux - Mots-clés optimisés FR/EN/ES
// Généré par expert SEO spécialisé gaming et serveurs privés

export const ADVANCED_GAME_KEYWORDS = {
  minecraft: {
    fr: {
      primary: [
        'serveur privé minecraft', 'serveur minecraft français', 'top serveur minecraft',
        'meilleur serveur minecraft', 'serveur minecraft gratuit', 'minecraft private server français'
      ],
      gameTypes: [
        'serveur minecraft survival', 'serveur minecraft creative', 'serveur minecraft pvp',
        'serveur minecraft skyblock', 'serveur minecraft factions', 'serveur minecraft mini-jeux',
        'serveur minecraft prison', 'serveur minecraft towny', 'serveur minecraft anarchy',
        'serveur minecraft moddé', 'serveur minecraft vanilla', 'serveur minecraft hardcore',
        'serveur minecraft bedwars', 'serveur minecraft kitpvp', 'serveur minecraft oneblock'
      ],
      versions: [
        'serveur minecraft 1.20', 'serveur minecraft 1.19', 'serveur minecraft 1.18',
        'serveur minecraft 1.16', 'serveur minecraft 1.12', 'serveur minecraft java',
        'serveur minecraft bedrock', 'serveur minecraft pe', 'serveur minecraft pocket edition'
      ],
      qualifiers: [
        'classement serveur minecraft', 'liste serveur minecraft', 'vote serveur minecraft',
        'serveur minecraft actif', 'serveur minecraft français', 'serveur minecraft sans whitelist',
        'serveur minecraft crack', 'serveur minecraft premium', 'serveur minecraft roleplay'
      ]
    },
    en: {
      primary: [
        'minecraft private server', 'minecraft server list', 'best minecraft server',
        'top minecraft servers', 'minecraft server english', 'free minecraft server'
      ],
      gameTypes: [
        'minecraft survival server', 'minecraft creative server', 'minecraft pvp server',
        'minecraft skyblock server', 'minecraft factions server', 'minecraft minigames server',
        'minecraft prison server', 'minecraft towny server', 'minecraft anarchy server',
        'minecraft modded server', 'minecraft vanilla server', 'minecraft hardcore server',
        'minecraft bedwars server', 'minecraft kitpvp server', 'minecraft oneblock server'
      ],
      versions: [
        'minecraft 1.20 server', 'minecraft 1.19 server', 'minecraft 1.18 server',
        'minecraft 1.16 server', 'minecraft 1.12 server', 'minecraft java server',
        'minecraft bedrock server', 'minecraft pe server', 'minecraft pocket edition server'
      ],
      qualifiers: [
        'minecraft server ranking', 'minecraft server voting', 'active minecraft server',
        'minecraft server', 'minecraft server no whitelist', 'minecraft cracked server',
        'minecraft premium server', 'minecraft roleplay server', 'english minecraft server'
      ]
    },
    es: {
      primary: [
        'servidor minecraft privado', 'servidor minecraft español', 'top servidor minecraft',
        'mejor servidor minecraft', 'servidor minecraft gratis', 'minecraft private server español'
      ],
      gameTypes: [
        'servidor minecraft survival', 'servidor minecraft creative', 'servidor minecraft pvp',
        'servidor minecraft skyblock', 'servidor minecraft factions', 'servidor minecraft mini-juegos',
        'servidor minecraft prison', 'servidor minecraft towny', 'servidor minecraft anarchy',
        'servidor minecraft modded', 'servidor minecraft vanilla', 'servidor minecraft hardcore',
        'servidor minecraft bedwars', 'servidor minecraft kitpvp', 'servidor minecraft oneblock'
      ],
      versions: [
        'servidor minecraft 1.20', 'servidor minecraft 1.19', 'servidor minecraft 1.18',
        'servidor minecraft 1.16', 'servidor minecraft 1.12', 'servidor minecraft java',
        'servidor minecraft bedrock', 'servidor minecraft pe', 'servidor minecraft pocket edition'
      ],
      qualifiers: [
        'ranking servidor minecraft', 'lista servidor minecraft', 'votar servidor minecraft',
        'servidor minecraft activo', 'servidor minecraft español', 'servidor minecraft sin whitelist',
        'servidor minecraft crackeado', 'servidor minecraft premium', 'servidor minecraft roleplay'
      ]
    }
  },

  'dofus-retro': {
    fr: {
      primary: [
        'serveur privé dofus retro', 'serveur dofus 1.29', 'top serveur dofus retro',
        'meilleur serveur dofus retro', 'serveur dofus retro français', 'dofus retro private server'
      ],
      versions: [
        'serveur dofus 1.29', 'serveur dofus beta', 'serveur dofus 1.3',
        'serveur dofus ancien', 'serveur dofus nostalgie', 'serveur dofus oldschool'
      ],
      features: [
        'serveur dofus retro kamas facile', 'serveur dofus retro pvp', 'serveur dofus retro pvm',
        'serveur dofus retro craft', 'serveur dofus retro économie', 'serveur dofus retro kolossium',
        'serveur dofus retro multi-compte', 'serveur dofus retro mono-compte', 'serveur dofus retro héroïque'
      ],
      rates: [
        'serveur dofus retro x2', 'serveur dofus retro x5', 'serveur dofus retro x10',
        'serveur dofus retro rates customs', 'serveur dofus retro exp rapide', 'serveur dofus retro drop amélioré'
      ]
    },
    en: {
      primary: [
        'dofus retro private server', 'dofus 1.29 server', 'best dofus retro server',
        'top dofus retro servers', 'dofus retro english server', 'dofus retro server list'
      ],
      versions: [
        'dofus 1.29 server', 'dofus beta server', 'dofus 1.3 server',
        'old dofus server', 'nostalgic dofus server', 'oldschool dofus server'
      ],
      features: [
        'dofus retro easy kamas', 'dofus retro pvp server', 'dofus retro pvm server',
        'dofus retro craft server', 'dofus retro economy', 'dofus retro kolosseum',
        'dofus retro multi-account', 'dofus retro mono-account', 'dofus retro heroic'
      ],
      rates: [
        'dofus retro x2 rates', 'dofus retro x5 rates', 'dofus retro x10 rates',
        'dofus retro custom rates', 'dofus retro fast exp', 'dofus retro enhanced drop'
      ]
    },
    es: {
      primary: [
        'servidor dofus retro privado', 'servidor dofus 1.29', 'top servidor dofus retro',
        'mejor servidor dofus retro', 'servidor dofus retro español', 'dofus retro private server español'
      ],
      versions: [
        'servidor dofus 1.29', 'servidor dofus beta', 'servidor dofus 1.3',
        'servidor dofus antiguo', 'servidor dofus nostalgia', 'servidor dofus oldschool'
      ],
      features: [
        'servidor dofus retro kamas fácil', 'servidor dofus retro pvp', 'servidor dofus retro pvm',
        'servidor dofus retro craft', 'servidor dofus retro economía', 'servidor dofus retro kolossium',
        'servidor dofus retro multi-cuenta', 'servidor dofus retro mono-cuenta', 'servidor dofus retro heroico'
      ],
      rates: [
        'servidor dofus retro x2', 'servidor dofus retro x5', 'servidor dofus retro x10',
        'servidor dofus retro rates custom', 'servidor dofus retro exp rápida', 'servidor dofus retro drop mejorado'
      ]
    }
  },

  'dofus-2x': {
    fr: {
      primary: [
        'serveur privé dofus', 'top serveur dofus', 'meilleur serveur dofus',
        'serveur privé dofus 2', 'serveur dofus 2.70', 'top serveur dofus 2',
        'meilleur serveur dofus 2', 'serveur dofus 2 français', 'dofus 2 private server'
      ],
      versions: [
        'serveur dofus 2.70', 'serveur dofus 2.69', 'serveur dofus 2.68',
        'serveur dofus 2.0', 'serveur dofus unity', 'serveur dofus touch'
      ],
      features: [
        'serveur dofus 2 kamas facile', 'serveur dofus 2 pvp', 'serveur dofus 2 pvm',
        'serveur dofus 2 craft', 'serveur dofus 2 économie', 'serveur dofus 2 kolossium',
        'serveur dofus 2 multi-compte', 'serveur dofus 2 mono-compte', 'serveur dofus 2 héroïque',
        'serveur dofus 2 temporis', 'serveur dofus 2 temporis like'
      ],
      rates: [
        'serveur dofus 2 x2', 'serveur dofus 2 x5', 'serveur dofus 2 x10',
        'serveur dofus 2 rates customs', 'serveur dofus 2 exp rapide', 'serveur dofus 2 drop amélioré'
      ]
    },
    en: {
      primary: [
        'dofus private server', 'top dofus server', 'best dofus server',
        'dofus 2 private server', 'dofus 2.70 server', 'best dofus 2 server',
        'top dofus 2 servers', 'dofus 2 english server', 'dofus 2 server list'
      ],
      versions: [
        'dofus 2.70 server', 'dofus 2.69 server', 'dofus 2.68 server',
        'dofus 2.0 server', 'dofus unity server', 'dofus touch server'
      ],
      features: [
        'dofus 2 easy kamas', 'dofus 2 pvp server', 'dofus 2 pvm server',
        'dofus 2 craft server', 'dofus 2 economy', 'dofus 2 kolosseum',
        'dofus 2 multi-account', 'dofus 2 mono-account', 'dofus 2 heroic',
        'dofus 2 temporis', 'dofus 2 temporis like'
      ],
      rates: [
        'dofus 2 x2 rates', 'dofus 2 x5 rates', 'dofus 2 x10 rates',
        'dofus 2 custom rates', 'dofus 2 fast exp', 'dofus 2 enhanced drop'
      ]
    },
    es: {
      primary: [
        'servidor privado dofus', 'top servidor dofus', 'mejor servidor dofus',
        'servidor dofus 2 privado', 'servidor dofus 2.70', 'top servidor dofus 2',
        'mejor servidor dofus 2', 'servidor dofus 2 español', 'dofus 2 private server español'
      ],
      versions: [
        'servidor dofus 2.70', 'servidor dofus 2.69', 'servidor dofus 2.68',
        'servidor dofus 2.0', 'servidor dofus unity', 'servidor dofus touch'
      ],
      features: [
        'servidor dofus 2 kamas fácil', 'servidor dofus 2 pvp', 'servidor dofus 2 pvm',
        'servidor dofus 2 craft', 'servidor dofus 2 economía', 'servidor dofus 2 kolossium',
        'servidor dofus 2 multi-cuenta', 'servidor dofus 2 mono-cuenta', 'servidor dofus 2 heroico',
        'servidor dofus 2 temporis', 'servidor dofus 2 temporis like'
      ],
      rates: [
        'servidor dofus 2 x2', 'servidor dofus 2 x5', 'servidor dofus 2 x10',
        'servidor dofus 2 rates custom', 'servidor dofus 2 exp rápida', 'servidor dofus 2 drop mejorado'
      ]
    }
  },

  'world-of-warcraft': {
    fr: {
      primary: [
        'serveur privé wow', 'serveur wow français', 'top serveur wow',
        'meilleur serveur wow', 'serveur wow gratuit', 'wow private server français'
      ],
      expansions: [
        'serveur wow classic', 'serveur wow vanilla', 'serveur wow tbc', 'serveur wow burning crusade',
        'serveur wow wotlk', 'serveur wow lich king', 'serveur wow cataclysm', 'serveur wow mists of pandaria',
        'serveur wow warlords of draenor', 'serveur wow legion', 'serveur wow bfa', 'serveur wow battle for azeroth',
        'serveur wow shadowlands', 'serveur wow dragonflight', 'serveur wow hardcore'
      ],
      types: [
        'serveur wow pve', 'serveur wow pvp', 'serveur wow rp', 'serveur wow rp-pvp',
        'serveur wow blizzlike', 'serveur wow fun', 'serveur wow custom', 'serveur wow instant',
        'serveur wow progressive', 'serveur wow fresh', 'serveur wow français rp'
      ],
      rates: [
        'serveur wow x1', 'serveur wow x2', 'serveur wow x5', 'serveur wow x10',
        'serveur wow x15', 'serveur wow blizzlike rates', 'serveur wow rates customs'
      ]
    },
    en: {
      primary: [
        'wow private server', 'world of warcraft private server', 'best wow server',
        'top wow servers', 'wow server english', 'free wow server'
      ],
      expansions: [
        'wow classic server', 'wow vanilla server', 'wow tbc server', 'wow burning crusade server',
        'wow wotlk server', 'wow lich king server', 'wow cataclysm server', 'wow mists of pandaria server',
        'wow warlords of draenor server', 'wow legion server', 'wow bfa server', 'wow battle for azeroth server',
        'wow shadowlands server', 'wow dragonflight server', 'wow hardcore server'
      ],
      types: [
        'wow pve server', 'wow pvp server', 'wow rp server', 'wow rp-pvp server',
        'wow blizzlike server', 'wow fun server', 'wow custom server', 'wow instant server',
        'wow progressive server', 'wow fresh server', 'wow english rp server'
      ],
      rates: [
        'wow x1 server', 'wow x2 server', 'wow x5 server', 'wow x10 server',
        'wow x15 server', 'wow blizzlike rates', 'wow custom rates server'
      ]
    },
    es: {
      primary: [
        'servidor wow privado', 'servidor world of warcraft privado', 'mejor servidor wow',
        'top servidor wow', 'servidor wow español', 'servidor wow gratis'
      ],
      expansions: [
        'servidor wow classic', 'servidor wow vanilla', 'servidor wow tbc', 'servidor wow burning crusade',
        'servidor wow wotlk', 'servidor wow lich king', 'servidor wow cataclysm', 'servidor wow mists of pandaria',
        'servidor wow warlords of draenor', 'servidor wow legion', 'servidor wow bfa', 'servidor wow battle for azeroth',
        'servidor wow shadowlands', 'servidor wow dragonflight', 'servidor wow hardcore'
      ],
      types: [
        'servidor wow pve', 'servidor wow pvp', 'servidor wow rp', 'servidor wow rp-pvp',
        'servidor wow blizzlike', 'servidor wow fun', 'servidor wow custom', 'servidor wow instant',
        'servidor wow progresivo', 'servidor wow fresh', 'servidor wow español rp'
      ],
      rates: [
        'servidor wow x1', 'servidor wow x2', 'servidor wow x5', 'servidor wow x10',
        'servidor wow x15', 'servidor wow blizzlike rates', 'servidor wow rates custom'
      ]
    }
  },

  'counter-strike-2': {
    fr: {
      primary: [
        'serveur cs2 français', 'counter-strike 2 server france', 'serveur cs2',
        'meilleur serveur cs2', 'top serveur cs2', 'serveur counter-strike 2'
      ],
      gameModes: [
        'serveur cs2 deathmatch', 'serveur cs2 surf', 'serveur cs2 bhop', 'serveur cs2 kz',
        'serveur cs2 retake', 'serveur cs2 aim', 'serveur cs2 1v1', 'serveur cs2 aim_map',
        'serveur cs2 jailbreak', 'serveur cs2 zombie', 'serveur cs2 gungame', 'serveur cs2 awp',
        'serveur cs2 knife', 'serveur cs2 headshot only', 'serveur cs2 scoutzknivez'
      ],
      competitive: [
        'serveur cs2 competitif', 'serveur cs2 matchmaking', 'serveur cs2 faceit',
        'serveur cs2 128 tick', 'serveur cs2 subtick', 'serveur cs2 anti-cheat'
      ],
      community: [
        'cs2 community server', 'serveur cs2 communautaire', 'serveur cs2 français actif',
        'serveur cs2 ping faible', 'serveur cs2 france', 'serveur cs2 europe'
      ]
    },
    en: {
      primary: [
        'cs2 server', 'counter-strike 2 server', 'best cs2 server',
        'top cs2 servers', 'cs2 community server', 'counter-strike 2 community'
      ],
      gameModes: [
        'cs2 deathmatch server', 'cs2 surf server', 'cs2 bhop server', 'cs2 kz server',
        'cs2 retake server', 'cs2 aim server', 'cs2 1v1 server', 'cs2 aim_map server',
        'cs2 jailbreak server', 'cs2 zombie server', 'cs2 gungame server', 'cs2 awp server',
        'cs2 knife server', 'cs2 headshot only server', 'cs2 scoutzknivez server'
      ],
      competitive: [
        'cs2 competitive server', 'cs2 matchmaking server', 'cs2 faceit server',
        'cs2 128 tick server', 'cs2 subtick server', 'cs2 anti-cheat server'
      ],
      community: [
        'cs2 community server', 'cs2 community', 'active cs2 server',
        'low ping cs2 server', 'cs2 server english', 'cs2 server europe'
      ]
    },
    es: {
      primary: [
        'servidor cs2 español', 'counter-strike 2 server españa', 'servidor cs2',
        'mejor servidor cs2', 'top servidor cs2', 'servidor counter-strike 2'
      ],
      gameModes: [
        'servidor cs2 deathmatch', 'servidor cs2 surf', 'servidor cs2 bhop', 'servidor cs2 kz',
        'servidor cs2 retake', 'servidor cs2 aim', 'servidor cs2 1v1', 'servidor cs2 aim_map',
        'servidor cs2 jailbreak', 'servidor cs2 zombie', 'servidor cs2 gungame', 'servidor cs2 awp',
        'servidor cs2 knife', 'servidor cs2 headshot only', 'servidor cs2 scoutzknivez'
      ],
      competitive: [
        'servidor cs2 competitivo', 'servidor cs2 matchmaking', 'servidor cs2 faceit',
        'servidor cs2 128 tick', 'servidor cs2 subtick', 'servidor cs2 anti-cheat'
      ],
      community: [
        'cs2 community server', 'servidor cs2 comunidad', 'servidor cs2 español activo',
        'servidor cs2 ping bajo', 'servidor cs2 españa', 'servidor cs2 europa'
      ]
    }
  },

  'counter-strike-global-offensive': {
    fr: {
      primary: [
        'serveur csgo français', 'counter-strike go server france', 'serveur cs:go',
        'meilleur serveur csgo', 'top serveur csgo', 'serveur counter-strike go'
      ],
      gameModes: [
        'serveur csgo deathmatch', 'serveur csgo surf', 'serveur csgo bhop', 'serveur csgo kz',
        'serveur csgo retake', 'serveur csgo aim', 'serveur csgo 1v1', 'serveur csgo aim_map',
        'serveur csgo jailbreak', 'serveur csgo zombie', 'serveur csgo gungame', 'serveur csgo awp',
        'serveur csgo knife', 'serveur csgo headshot only', 'serveur csgo scoutzknivez'
      ],
      competitive: [
        'serveur csgo competitif', 'serveur csgo matchmaking', 'serveur csgo faceit',
        'serveur csgo 128 tick', 'serveur csgo anti-cheat', 'serveur csgo esea'
      ],
      community: [
        'csgo community server', 'serveur csgo communautaire', 'serveur csgo français actif',
        'serveur csgo ping faible', 'serveur csgo france', 'serveur csgo europe'
      ]
    },
    en: {
      primary: [
        'csgo server', 'counter-strike go server', 'best csgo server',
        'top csgo servers', 'csgo community server', 'counter-strike global offensive server'
      ],
      gameModes: [
        'csgo deathmatch server', 'csgo surf server', 'csgo bhop server', 'csgo kz server',
        'csgo retake server', 'csgo aim server', 'csgo 1v1 server', 'csgo aim_map server',
        'csgo jailbreak server', 'csgo zombie server', 'csgo gungame server', 'csgo awp server',
        'csgo knife server', 'csgo headshot only server', 'csgo scoutzknivez server'
      ],
      competitive: [
        'csgo competitive server', 'csgo matchmaking server', 'csgo faceit server',
        'csgo 128 tick server', 'csgo anti-cheat server', 'csgo esea server'
      ],
      community: [
        'csgo community server', 'csgo community', 'active csgo server',
        'low ping csgo server', 'csgo server english', 'csgo server europe'
      ]
    },
    es: {
      primary: [
        'servidor csgo español', 'counter-strike go server españa', 'servidor cs:go',
        'mejor servidor csgo', 'top servidor csgo', 'servidor counter-strike go'
      ],
      gameModes: [
        'servidor csgo deathmatch', 'servidor csgo surf', 'servidor csgo bhop', 'servidor csgo kz',
        'servidor csgo retake', 'servidor csgo aim', 'servidor csgo 1v1', 'servidor csgo aim_map',
        'servidor csgo jailbreak', 'servidor csgo zombie', 'servidor csgo gungame', 'servidor csgo awp',
        'servidor csgo knife', 'servidor csgo headshot only', 'servidor csgo scoutzknivez'
      ],
      competitive: [
        'servidor csgo competitivo', 'servidor csgo matchmaking', 'servidor csgo faceit',
        'servidor csgo 128 tick', 'servidor csgo anti-cheat', 'servidor csgo esea'
      ],
      community: [
        'csgo community server', 'servidor csgo comunidad', 'servidor csgo español activo',
        'servidor csgo ping bajo', 'servidor csgo españa', 'servidor csgo europa'
      ]
    }
  },

  'counter-strike-source': {
    fr: {
      primary: [
        'serveur css français', 'counter-strike source server france', 'serveur cs:s',
        'meilleur serveur css', 'top serveur css', 'serveur counter-strike source'
      ],
      gameModes: [
        'serveur css deathmatch', 'serveur css surf', 'serveur css bhop', 'serveur css kz',
        'serveur css gungame', 'serveur css zombie', 'serveur css jailbreak', 'serveur css awp',
        'serveur css aim', 'serveur css 1v1', 'serveur css scoutzknivez', 'serveur css fy'
      ],
      community: [
        'css community server', 'serveur css communautaire', 'serveur css français actif',
        'serveur css nostalgique', 'serveur css oldschool', 'serveur css vintage'
      ]
    },
    en: {
      primary: [
        'css server', 'counter-strike source server', 'best css server',
        'top css servers', 'css community server', 'counter-strike source community'
      ],
      gameModes: [
        'css deathmatch server', 'css surf server', 'css bhop server', 'css kz server',
        'css gungame server', 'css zombie server', 'css jailbreak server', 'css awp server',
        'css aim server', 'css 1v1 server', 'css scoutzknivez server', 'css fy server'
      ],
      community: [
        'css community server', 'css community', 'active css server',
        'nostalgic css server', 'oldschool css server', 'vintage css server'
      ]
    },
    es: {
      primary: [
        'servidor css español', 'counter-strike source server españa', 'servidor cs:s',
        'mejor servidor css', 'top servidor css', 'servidor counter-strike source'
      ],
      gameModes: [
        'servidor css deathmatch', 'servidor css surf', 'servidor css bhop', 'servidor css kz',
        'servidor css gungame', 'servidor css zombie', 'servidor css jailbreak', 'servidor css awp',
        'servidor css aim', 'servidor css 1v1', 'servidor css scoutzknivez', 'servidor css fy'
      ],
      community: [
        'css community server', 'servidor css comunidad', 'servidor css español activo',
        'servidor css nostálgico', 'servidor css oldschool', 'servidor css vintage'
      ]
    }
  },

  'gta-v-fivem': {
    fr: {
      primary: [
        'serveur gta rp français', 'serveur fivem français', 'gta roleplay français',
        'serveur gta v rp', 'meilleur serveur gta rp', 'top serveur fivem'
      ],
      roleplay: [
        'serveur gta rp immersif', 'serveur gta rp sérieux', 'serveur gta rp réaliste',
        'serveur gta rp police', 'serveur gta rp ems', 'serveur gta rp gang',
        'serveur gta rp mafia', 'serveur gta rp gouvernement', 'serveur gta rp justice'
      ],
      economy: [
        'serveur gta rp économie réaliste', 'serveur gta rp jobs variés', 'serveur gta rp entreprise',
        'serveur gta rp immobilier', 'serveur gta rp banking', 'serveur gta rp crypto'
      ],
      features: [
        'serveur gta rp mapping custom', 'serveur gta rp véhicules custom', 'serveur gta rp vêtements custom',
        'serveur gta rp drugs system', 'serveur gta rp housing system', 'serveur gta rp phone system'
      ]
    },
    en: {
      primary: [
        'gta rp server english', 'fivem server english', 'gta roleplay english',
        'gta v rp server', 'best gta rp server', 'top fivem server'
      ],
      roleplay: [
        'immersive gta rp server', 'serious gta rp server', 'realistic gta rp server',
        'gta rp police server', 'gta rp ems server', 'gta rp gang server',
        'gta rp mafia server', 'gta rp government server', 'gta rp justice server'
      ],
      economy: [
        'realistic economy gta rp', 'varied jobs gta rp', 'business gta rp server',
        'real estate gta rp', 'banking gta rp server', 'crypto gta rp server'
      ],
      features: [
        'custom mapping gta rp', 'custom vehicles gta rp', 'custom clothing gta rp',
        'drugs system gta rp', 'housing system gta rp', 'phone system gta rp'
      ]
    },
    es: {
      primary: [
        'servidor gta rp español', 'servidor fivem español', 'gta roleplay español',
        'servidor gta v rp', 'mejor servidor gta rp', 'top servidor fivem'
      ],
      roleplay: [
        'servidor gta rp inmersivo', 'servidor gta rp serio', 'servidor gta rp realista',
        'servidor gta rp policía', 'servidor gta rp ems', 'servidor gta rp pandilla',
        'servidor gta rp mafia', 'servidor gta rp gobierno', 'servidor gta rp justicia'
      ],
      economy: [
        'servidor gta rp economía realista', 'servidor gta rp trabajos variados', 'servidor gta rp empresa',
        'servidor gta rp inmobiliario', 'servidor gta rp banking', 'servidor gta rp crypto'
      ],
      features: [
        'servidor gta rp mapping custom', 'servidor gta rp vehículos custom', 'servidor gta rp ropa custom',
        'servidor gta rp sistema drogas', 'servidor gta rp sistema casas', 'servidor gta rp sistema teléfono'
      ]
    }
  },

  rust: {
    fr: {
      primary: [
        'serveur rust français', 'serveur rust privé', 'top serveur rust',
        'meilleur serveur rust', 'serveur rust france', 'rust private server français'
      ],
      types: [
        'serveur rust vanilla', 'serveur rust modded', 'serveur rust pve', 'serveur rust pvp',
        'serveur rust solo duo', 'serveur rust trio', 'serveur rust no group limit',
        'serveur rust bow only', 'serveur rust primitive', 'serveur rust battlefield'
      ],
      rates: [
        'serveur rust x2', 'serveur rust x3', 'serveur rust x5', 'serveur rust x10',
        'serveur rust gather', 'serveur rust rates customs', 'serveur rust loot+'
      ],
      features: [
        'serveur rust wipe hebdomadaire', 'serveur rust wipe mensuel', 'serveur rust no wipe',
        'serveur rust kits', 'serveur rust tp', 'serveur rust remove', 'serveur rust clans',
        'serveur rust shops', 'serveur rust economics', 'serveur rust skin system'
      ]
    },
    en: {
      primary: [
        'rust server english', 'rust private server', 'best rust server',
        'top rust servers', 'rust server list', 'english rust server'
      ],
      types: [
        'rust vanilla server', 'rust modded server', 'rust pve server', 'rust pvp server',
        'rust solo duo server', 'rust trio server', 'rust no group limit server',
        'rust bow only server', 'rust primitive server', 'rust battlefield server'
      ],
      rates: [
        'rust x2 server', 'rust x3 server', 'rust x5 server', 'rust x10 server',
        'rust gather server', 'rust custom rates server', 'rust loot+ server'
      ],
      features: [
        'rust weekly wipe server', 'rust monthly wipe server', 'rust no wipe server',
        'rust kits server', 'rust tp server', 'rust remove server', 'rust clans server',
        'rust shops server', 'rust economics server', 'rust skin system server'
      ]
    },
    es: {
      primary: [
        'servidor rust español', 'servidor rust privado', 'mejor servidor rust',
        'top servidor rust', 'servidor rust españa', 'rust private server español'
      ],
      types: [
        'servidor rust vanilla', 'servidor rust modded', 'servidor rust pve', 'servidor rust pvp',
        'servidor rust solo duo', 'servidor rust trio', 'servidor rust sin límite grupo',
        'servidor rust bow only', 'servidor rust primitivo', 'servidor rust battlefield'
      ],
      rates: [
        'servidor rust x2', 'servidor rust x3', 'servidor rust x5', 'servidor rust x10',
        'servidor rust gather', 'servidor rust rates custom', 'servidor rust loot+'
      ],
      features: [
        'servidor rust wipe semanal', 'servidor rust wipe mensual', 'servidor rust sin wipe',
        'servidor rust kits', 'servidor rust tp', 'servidor rust remove', 'servidor rust clanes',
        'servidor rust tiendas', 'servidor rust economics', 'servidor rust sistema skins'
      ]
    }
  },

  dayz: {
    fr: {
      primary: [
        'serveur dayz français', 'serveur dayz privé', 'top serveur dayz',
        'meilleur serveur dayz', 'serveur dayz france', 'dayz private server français'
      ],
      types: [
        'serveur dayz vanilla', 'serveur dayz modded', 'serveur dayz pve', 'serveur dayz pvp',
        'serveur dayz rp', 'serveur dayz hardcore', 'serveur dayz casual', 'serveur dayz survival'
      ],
      mods: [
        'serveur dayz expansion', 'serveur dayz trader', 'serveur dayz base building',
        'serveur dayz cars', 'serveur dayz weapons', 'serveur dayz zombies+',
        'serveur dayz custom zombies', 'serveur dayz winter chernarus'
      ],
      features: [
        'serveur dayz persistence on', 'serveur dayz persistence off', 'serveur dayz whitelist',
        'serveur dayz no whitelist', 'serveur dayz boosted loot', 'serveur dayz more cars',
        'serveur dayz killfeed', 'serveur dayz discord integration', 'serveur dayz admin actif'
      ]
    },
    en: {
      primary: [
        'dayz server english', 'dayz private server', 'best dayz server',
        'top dayz servers', 'dayz server list', 'english dayz server'
      ],
      types: [
        'dayz vanilla server', 'dayz modded server', 'dayz pve server', 'dayz pvp server',
        'dayz rp server', 'dayz hardcore server', 'dayz casual server', 'dayz survival server'
      ],
      mods: [
        'dayz expansion server', 'dayz trader server', 'dayz base building server',
        'dayz cars server', 'dayz weapons server', 'dayz zombies+ server',
        'dayz custom zombies server', 'dayz winter chernarus server'
      ],
      features: [
        'dayz persistence on server', 'dayz persistence off server', 'dayz whitelist server',
        'dayz no whitelist server', 'dayz boosted loot server', 'dayz more cars server',
        'dayz killfeed server', 'dayz discord integration server', 'dayz active admin server'
      ]
    },
    es: {
      primary: [
        'servidor dayz español', 'servidor dayz privado', 'mejor servidor dayz',
        'top servidor dayz', 'servidor dayz españa', 'dayz private server español'
      ],
      types: [
        'servidor dayz vanilla', 'servidor dayz modded', 'servidor dayz pve', 'servidor dayz pvp',
        'servidor dayz rp', 'servidor dayz hardcore', 'servidor dayz casual', 'servidor dayz survival'
      ],
      mods: [
        'servidor dayz expansion', 'servidor dayz trader', 'servidor dayz base building',
        'servidor dayz cars', 'servidor dayz weapons', 'servidor dayz zombies+',
        'servidor dayz zombies custom', 'servidor dayz winter chernarus'
      ],
      features: [
        'servidor dayz persistence on', 'servidor dayz persistence off', 'servidor dayz whitelist',
        'servidor dayz sin whitelist', 'servidor dayz loot aumentado', 'servidor dayz más coches',
        'servidor dayz killfeed', 'servidor dayz integración discord', 'servidor dayz admin activo'
      ]
    }
  },

  'garrys-mod': {
    fr: {
      primary: [
        'serveur gmod français', 'serveur garry\'s mod français', 'top serveur gmod',
        'meilleur serveur gmod', 'serveur gmod france', 'garrys mod server français'
      ],
      gameModes: [
        'serveur darkrp français', 'serveur gmod ttt', 'serveur gmod sandbox', 'serveur gmod roleplay',
        'serveur gmod jailbreak', 'serveur gmod prophunt', 'serveur gmod murder', 'serveur gmod deathrun',
        'serveur gmod zombie survival', 'serveur gmod guess who', 'serveur gmod clone wars rp'
      ],
      darkrp: [
        'serveur darkrp jobs variés', 'serveur darkrp économie', 'serveur darkrp gangs',
        'serveur darkrp police', 'serveur darkrp maire', 'serveur darkrp printers',
        'serveur darkrp cars', 'serveur darkrp weapons', 'serveur darkrp vip'
      ],
      features: [
        'serveur gmod addons custom', 'serveur gmod maps custom', 'serveur gmod workshop',
        'serveur gmod fastdl', 'serveur gmod anti-cheat', 'serveur gmod admin actif'
      ]
    },
    en: {
      primary: [
        'gmod server english', 'garrys mod server english', 'best gmod server',
        'top gmod servers', 'gmod server list', 'english gmod server'
      ],
      gameModes: [
        'darkrp server english', 'gmod ttt server', 'gmod sandbox server', 'gmod roleplay server',
        'gmod jailbreak server', 'gmod prophunt server', 'gmod murder server', 'gmod deathrun server',
        'gmod zombie survival server', 'gmod guess who server', 'gmod clone wars rp server'
      ],
      darkrp: [
        'darkrp varied jobs server', 'darkrp economy server', 'darkrp gangs server',
        'darkrp police server', 'darkrp mayor server', 'darkrp printers server',
        'darkrp cars server', 'darkrp weapons server', 'darkrp vip server'
      ],
      features: [
        'gmod custom addons server', 'gmod custom maps server', 'gmod workshop server',
        'gmod fastdl server', 'gmod anti-cheat server', 'gmod active admin server'
      ]
    },
    es: {
      primary: [
        'servidor gmod español', 'servidor garry\'s mod español', 'mejor servidor gmod',
        'top servidor gmod', 'servidor gmod españa', 'garrys mod server español'
      ],
      gameModes: [
        'servidor darkrp español', 'servidor gmod ttt', 'servidor gmod sandbox', 'servidor gmod roleplay',
        'servidor gmod jailbreak', 'servidor gmod prophunt', 'servidor gmod murder', 'servidor gmod deathrun',
        'servidor gmod zombie survival', 'servidor gmod guess who', 'servidor gmod clone wars rp'
      ],
      darkrp: [
        'servidor darkrp trabajos variados', 'servidor darkrp economía', 'servidor darkrp pandillas',
        'servidor darkrp policía', 'servidor darkrp alcalde', 'servidor darkrp impresoras',
        'servidor darkrp coches', 'servidor darkrp armas', 'servidor darkrp vip'
      ],
      features: [
        'servidor gmod addons custom', 'servidor gmod mapas custom', 'servidor gmod workshop',
        'servidor gmod fastdl', 'servidor gmod anti-cheat', 'servidor gmod admin activo'
      ]
    }
  },

  'ark-survival': {
    fr: {
      primary: [
        'serveur ark français', 'serveur ark survival français', 'top serveur ark',
        'meilleur serveur ark', 'serveur ark france', 'ark server français'
      ],
      types: [
        'serveur ark pve', 'serveur ark pvp', 'serveur ark pve-c', 'serveur ark rp',
        'serveur ark vanilla', 'serveur ark modded', 'serveur ark cluster', 'serveur ark solo'
      ],
      maps: [
        'serveur ark island', 'serveur ark ragnarok', 'serveur ark extinction', 'serveur ark aberration',
        'serveur ark scorched earth', 'serveur ark valguero', 'serveur ark crystal isles',
        'serveur ark genesis', 'serveur ark fjordur', 'serveur ark lost island'
      ],
      rates: [
        'serveur ark x5', 'serveur ark x10', 'serveur ark x20', 'serveur ark boosted',
        'serveur ark tame rapide', 'serveur ark breed rapide', 'serveur ark harvest+'
      ]
    },
    en: {
      primary: [
        'ark server english', 'ark survival server english', 'best ark server',
        'top ark servers', 'ark server list', 'english ark server'
      ],
      types: [
        'ark pve server', 'ark pvp server', 'ark pve-c server', 'ark rp server',
        'ark vanilla server', 'ark modded server', 'ark cluster server', 'ark solo server'
      ],
      maps: [
        'ark island server', 'ark ragnarok server', 'ark extinction server', 'ark aberration server',
        'ark scorched earth server', 'ark valguero server', 'ark crystal isles server',
        'ark genesis server', 'ark fjordur server', 'ark lost island server'
      ],
      rates: [
        'ark x5 server', 'ark x10 server', 'ark x20 server', 'ark boosted server',
        'ark fast tame server', 'ark fast breed server', 'ark harvest+ server'
      ]
    },
    es: {
      primary: [
        'servidor ark español', 'servidor ark survival español', 'mejor servidor ark',
        'top servidor ark', 'servidor ark españa', 'ark server español'
      ],
      types: [
        'servidor ark pve', 'servidor ark pvp', 'servidor ark pve-c', 'servidor ark rp',
        'servidor ark vanilla', 'servidor ark modded', 'servidor ark cluster', 'servidor ark solo'
      ],
      maps: [
        'servidor ark island', 'servidor ark ragnarok', 'servidor ark extinction', 'servidor ark aberration',
        'servidor ark scorched earth', 'servidor ark valguero', 'servidor ark crystal isles',
        'servidor ark genesis', 'servidor ark fjordur', 'servidor ark lost island'
      ],
      rates: [
        'servidor ark x5', 'servidor ark x10', 'servidor ark x20', 'servidor ark boosted',
        'servidor ark domesticar rápido', 'servidor ark criar rápido', 'servidor ark harvest+'
      ]
    }
  },

  // Continuons avec les autres jeux...
  'lineage-2': {
    fr: {
      primary: [
        'serveur lineage 2 français', 'serveur l2 français', 'top serveur lineage 2',
        'meilleur serveur l2', 'serveur lineage 2 france', 'lineage 2 private server français'
      ],
      chronicles: [
        'serveur l2 c4', 'serveur l2 interlude', 'serveur l2 kamael', 'serveur l2 hellbound',
        'serveur l2 gracia', 'serveur l2 freya', 'serveur l2 high five', 'serveur l2 goddess of destruction',
        'serveur l2 glory days', 'serveur l2 ertheia', 'serveur l2 classic'
      ],
      rates: [
        'serveur l2 x1', 'serveur l2 x5', 'serveur l2 x10', 'serveur l2 x15',
        'serveur l2 x25', 'serveur l2 x50', 'serveur l2 mid rate', 'serveur l2 high rate'
      ],
      types: [
        'serveur l2 pvp', 'serveur l2 pve', 'serveur l2 low rate', 'serveur l2 mid rate',
        'serveur l2 high rate', 'serveur l2 fun', 'serveur l2 hardcore', 'serveur l2 olympiad'
      ]
    },
    en: {
      primary: [
        'lineage 2 server english', 'l2 server english', 'best lineage 2 server',
        'top l2 servers', 'lineage 2 private server', 'english l2 server'
      ],
      chronicles: [
        'l2 c4 server', 'l2 interlude server', 'l2 kamael server', 'l2 hellbound server',
        'l2 gracia server', 'l2 freya server', 'l2 high five server', 'l2 goddess of destruction server',
        'l2 glory days server', 'l2 ertheia server', 'l2 classic server'
      ],
      rates: [
        'l2 x1 server', 'l2 x5 server', 'l2 x10 server', 'l2 x15 server',
        'l2 x25 server', 'l2 x50 server', 'l2 mid rate server', 'l2 high rate server'
      ],
      types: [
        'l2 pvp server', 'l2 pve server', 'l2 low rate server', 'l2 mid rate server',
        'l2 high rate server', 'l2 fun server', 'l2 hardcore server', 'l2 olympiad server'
      ]
    },
    es: {
      primary: [
        'servidor lineage 2 español', 'servidor l2 español', 'mejor servidor lineage 2',
        'top servidor l2', 'servidor lineage 2 españa', 'lineage 2 private server español'
      ],
      chronicles: [
        'servidor l2 c4', 'servidor l2 interlude', 'servidor l2 kamael', 'servidor l2 hellbound',
        'servidor l2 gracia', 'servidor l2 freya', 'servidor l2 high five', 'servidor l2 goddess of destruction',
        'servidor l2 glory days', 'servidor l2 ertheia', 'servidor l2 classic'
      ],
      rates: [
        'servidor l2 x1', 'servidor l2 x5', 'servidor l2 x10', 'servidor l2 x15',
        'servidor l2 x25', 'servidor l2 x50', 'servidor l2 mid rate', 'servidor l2 high rate'
      ],
      types: [
        'servidor l2 pvp', 'servidor l2 pve', 'servidor l2 low rate', 'servidor l2 mid rate',
        'servidor l2 high rate', 'servidor l2 fun', 'servidor l2 hardcore', 'servidor l2 olympiad'
      ]
    }
  },

  'metin-2': {
    fr: {
      primary: [
        'serveur metin2 français', 'serveur mt2 français', 'top serveur metin2',
        'meilleur serveur mt2', 'serveur metin2 france', 'metin2 private server français'
      ],
      features: [
        'serveur metin2 yang facile', 'serveur metin2 exp rapide', 'serveur metin2 drop+',
        'serveur metin2 pvm', 'serveur metin2 pvp', 'serveur metin2 guild war',
        'serveur metin2 events', 'serveur metin2 costumes', 'serveur metin2 pets'
      ],
      rates: [
        'serveur metin2 x2', 'serveur metin2 x5', 'serveur metin2 x10', 'serveur metin2 x15',
        'serveur metin2 x20', 'serveur metin2 medium', 'serveur metin2 high rate'
      ],
      versions: [
        'serveur metin2 old school', 'serveur metin2 new school', 'serveur metin2 2008',
        'serveur metin2 classic', 'serveur metin2 retro', 'serveur metin2 modern'
      ]
    },
    en: {
      primary: [
        'metin2 server english', 'mt2 server english', 'best metin2 server',
        'top mt2 servers', 'metin2 private server', 'english metin2 server'
      ],
      features: [
        'metin2 easy yang server', 'metin2 fast exp server', 'metin2 drop+ server',
        'metin2 pvm server', 'metin2 pvp server', 'metin2 guild war server',
        'metin2 events server', 'metin2 costumes server', 'metin2 pets server'
      ],
      rates: [
        'metin2 x2 server', 'metin2 x5 server', 'metin2 x10 server', 'metin2 x15 server',
        'metin2 x20 server', 'metin2 medium server', 'metin2 high rate server'
      ],
      versions: [
        'metin2 old school server', 'metin2 new school server', 'metin2 2008 server',
        'metin2 classic server', 'metin2 retro server', 'metin2 modern server'
      ]
    },
    es: {
      primary: [
        'servidor metin2 español', 'servidor mt2 español', 'mejor servidor metin2',
        'top servidor mt2', 'servidor metin2 españa', 'metin2 private server español'
      ],
      features: [
        'servidor metin2 yang fácil', 'servidor metin2 exp rápida', 'servidor metin2 drop+',
        'servidor metin2 pvm', 'servidor metin2 pvp', 'servidor metin2 guild war',
        'servidor metin2 eventos', 'servidor metin2 costumes', 'servidor metin2 mascotas'
      ],
      rates: [
        'servidor metin2 x2', 'servidor metin2 x5', 'servidor metin2 x10', 'servidor metin2 x15',
        'servidor metin2 x20', 'servidor metin2 medium', 'servidor metin2 high rate'
      ],
      versions: [
        'servidor metin2 old school', 'servidor metin2 new school', 'servidor metin2 2008',
        'servidor metin2 classic', 'servidor metin2 retro', 'servidor metin2 modern'
      ]
    }
  },

  // Ajoutons les derniers jeux...
  aion: {
    fr: {
      primary: [
        'serveur aion français', 'serveur aion privé', 'top serveur aion',
        'meilleur serveur aion', 'serveur aion france', 'aion private server français'
      ],
      versions: [
        'serveur aion classic', 'serveur aion 1.0', 'serveur aion 2.0', 'serveur aion 3.0',
        'serveur aion 4.0', 'serveur aion retail like', 'serveur aion legacy'
      ],
      rates: [
        'serveur aion x1', 'serveur aion x2', 'serveur aion x5', 'serveur aion x10',
        'serveur aion custom rates', 'serveur aion fast leveling'
      ],
      features: [
        'serveur aion pvp', 'serveur aion pve', 'serveur aion abyss', 'serveur aion siege',
        'serveur aion events', 'serveur aion customs wings', 'serveur aion balanced'
      ]
    },
    en: {
      primary: [
        'aion server english', 'aion private server', 'best aion server',
        'top aion servers', 'aion server list', 'english aion server'
      ],
      versions: [
        'aion classic server', 'aion 1.0 server', 'aion 2.0 server', 'aion 3.0 server',
        'aion 4.0 server', 'aion retail like server', 'aion legacy server'
      ],
      rates: [
        'aion x1 server', 'aion x2 server', 'aion x5 server', 'aion x10 server',
        'aion custom rates server', 'aion fast leveling server'
      ],
      features: [
        'aion pvp server', 'aion pve server', 'aion abyss server', 'aion siege server',
        'aion events server', 'aion custom wings server', 'aion balanced server'
      ]
    },
    es: {
      primary: [
        'servidor aion español', 'servidor aion privado', 'mejor servidor aion',
        'top servidor aion', 'servidor aion españa', 'aion private server español'
      ],
      versions: [
        'servidor aion classic', 'servidor aion 1.0', 'servidor aion 2.0', 'servidor aion 3.0',
        'servidor aion 4.0', 'servidor aion retail like', 'servidor aion legacy'
      ],
      rates: [
        'servidor aion x1', 'servidor aion x2', 'servidor aion x5', 'servidor aion x10',
        'servidor aion rates custom', 'servidor aion subida rápida'
      ],
      features: [
        'servidor aion pvp', 'servidor aion pve', 'servidor aion abismo', 'servidor aion asedio',
        'servidor aion eventos', 'servidor aion alas custom', 'servidor aion equilibrado'
      ]
    }
  },

  'mu-online': {
    fr: {
      primary: [
        'serveur mu online français', 'serveur mu français', 'top serveur mu online',
        'meilleur serveur mu', 'serveur mu online france', 'mu online private server français'
      ],
      seasons: [
        'serveur mu season 1', 'serveur mu season 2', 'serveur mu season 3', 'serveur mu season 4',
        'serveur mu season 6', 'serveur mu season 9', 'serveur mu season 13', 'serveur mu season 16'
      ],
      rates: [
        'serveur mu x10', 'serveur mu x50', 'serveur mu x100', 'serveur mu x500',
        'serveur mu x1000', 'serveur mu medium', 'serveur mu high rate'
      ],
      features: [
        'serveur mu pvp', 'serveur mu pve', 'serveur mu castle siege', 'serveur mu devil square',
        'serveur mu blood castle', 'serveur mu chaos castle', 'serveur mu kalima', 'serveur mu events'
      ]
    },
    en: {
      primary: [
        'mu online server english', 'mu server english', 'best mu online server',
        'top mu servers', 'mu online private server', 'english mu server'
      ],
      seasons: [
        'mu season 1 server', 'mu season 2 server', 'mu season 3 server', 'mu season 4 server',
        'mu season 6 server', 'mu season 9 server', 'mu season 13 server', 'mu season 16 server'
      ],
      rates: [
        'mu x10 server', 'mu x50 server', 'mu x100 server', 'mu x500 server',
        'mu x1000 server', 'mu medium server', 'mu high rate server'
      ],
      features: [
        'mu pvp server', 'mu pve server', 'mu castle siege server', 'mu devil square server',
        'mu blood castle server', 'mu chaos castle server', 'mu kalima server', 'mu events server'
      ]
    },
    es: {
      primary: [
        'servidor mu online español', 'servidor mu español', 'mejor servidor mu online',
        'top servidor mu', 'servidor mu online españa', 'mu online private server español'
      ],
      seasons: [
        'servidor mu season 1', 'servidor mu season 2', 'servidor mu season 3', 'servidor mu season 4',
        'servidor mu season 6', 'servidor mu season 9', 'servidor mu season 13', 'servidor mu season 16'
      ],
      rates: [
        'servidor mu x10', 'servidor mu x50', 'servidor mu x100', 'servidor mu x500',
        'servidor mu x1000', 'servidor mu medium', 'servidor mu high rate'
      ],
      features: [
        'servidor mu pvp', 'servidor mu pve', 'servidor mu castle siege', 'servidor mu devil square',
        'servidor mu blood castle', 'servidor mu chaos castle', 'servidor mu kalima', 'servidor mu eventos'
      ]
    }
  },

  // Ajoutons les derniers jeux de votre base...
  'red-dead-redemption-2': {
    fr: {
      primary: [
        'serveur rdr2 français', 'serveur red dead redemption 2 français', 'serveur redm français',
        'top serveur rdr2', 'meilleur serveur red dead', 'serveur rdr2 rp français'
      ],
      roleplay: [
        'serveur rdr2 roleplay', 'serveur rdr2 rp immersif', 'serveur rdr2 western rp',
        'serveur rdr2 cow-boy rp', 'serveur rdr2 sheriff rp', 'serveur rdr2 bandit rp'
      ],
      features: [
        'serveur rdr2 économie réaliste', 'serveur rdr2 horses custom', 'serveur rdr2 gangs',
        'serveur rdr2 properties', 'serveur rdr2 hunting', 'serveur rdr2 fishing'
      ]
    },
    en: {
      primary: [
        'rdr2 server english', 'red dead redemption 2 server english', 'redm server english',
        'best rdr2 server', 'top red dead server', 'rdr2 rp server english'
      ],
      roleplay: [
        'rdr2 roleplay server', 'rdr2 immersive rp server', 'rdr2 western rp server',
        'rdr2 cowboy rp server', 'rdr2 sheriff rp server', 'rdr2 outlaw rp server'
      ],
      features: [
        'rdr2 realistic economy server', 'rdr2 custom horses server', 'rdr2 gangs server',
        'rdr2 properties server', 'rdr2 hunting server', 'rdr2 fishing server'
      ]
    },
    es: {
      primary: [
        'servidor rdr2 español', 'servidor red dead redemption 2 español', 'servidor redm español',
        'mejor servidor rdr2', 'top servidor red dead', 'servidor rdr2 rp español'
      ],
      roleplay: [
        'servidor rdr2 roleplay', 'servidor rdr2 rp inmersivo', 'servidor rdr2 western rp',
        'servidor rdr2 vaquero rp', 'servidor rdr2 sheriff rp', 'servidor rdr2 bandido rp'
      ],
      features: [
        'servidor rdr2 economía realista', 'servidor rdr2 caballos custom', 'servidor rdr2 pandillas',
        'servidor rdr2 propiedades', 'servidor rdr2 caza', 'servidor rdr2 pesca'
      ]
    }
  },

  // Terminons avec les derniers jeux...
  roblox: {
    fr: {
      primary: [
        'serveur roblox français', 'serveur roblox privé', 'top serveur roblox',
        'meilleur serveur roblox', 'serveur roblox france', 'roblox private server français'
      ],
      games: [
        'serveur roblox adopt me', 'serveur roblox jailbreak', 'serveur roblox arsenal',
        'serveur roblox tower of hell', 'serveur roblox piggy', 'serveur roblox mad city',
        'serveur roblox phantom forces', 'serveur roblox bloxburg', 'serveur roblox royale high'
      ],
      features: [
        'serveur roblox vip', 'serveur roblox robux gratuit', 'serveur roblox custom games',
        'serveur roblox events', 'serveur roblox roleplay', 'serveur roblox simulator'
      ]
    },
    en: {
      primary: [
        'roblox server english', 'roblox private server', 'best roblox server',
        'top roblox servers', 'roblox server list', 'english roblox server'
      ],
      games: [
        'roblox adopt me server', 'roblox jailbreak server', 'roblox arsenal server',
        'roblox tower of hell server', 'roblox piggy server', 'roblox mad city server',
        'roblox phantom forces server', 'roblox bloxburg server', 'roblox royale high server'
      ],
      features: [
        'roblox vip server', 'roblox free robux server', 'roblox custom games server',
        'roblox events server', 'roblox roleplay server', 'roblox simulator server'
      ]
    },
    es: {
      primary: [
        'servidor roblox español', 'servidor roblox privado', 'mejor servidor roblox',
        'top servidor roblox', 'servidor roblox españa', 'roblox private server español'
      ],
      games: [
        'servidor roblox adopt me', 'servidor roblox jailbreak', 'servidor roblox arsenal',
        'servidor roblox tower of hell', 'servidor roblox piggy', 'servidor roblox mad city',
        'servidor roblox phantom forces', 'servidor roblox bloxburg', 'servidor roblox royale high'
      ],
      features: [
        'servidor roblox vip', 'servidor roblox robux gratis', 'servidor roblox juegos custom',
        'servidor roblox eventos', 'servidor roblox roleplay', 'servidor roblox simulador'
      ]
    }
  }
};

// Types pour TypeScript
export type AdvancedGameKey = keyof typeof ADVANCED_GAME_KEYWORDS;
export type KeywordLanguage = 'fr' | 'en' | 'es';
export type KeywordCategory = 'primary' | 'gameTypes' | 'versions' | 'qualifiers' | 'features' | 'rates' | 'expansions' | 'types' | 'gameModes' | 'competitive' | 'community' | 'roleplay' | 'economy' | 'chronicles' | 'seasons' | 'mods' | 'maps' | 'darkrp' | 'games';

// Fonction utilitaire pour obtenir tous les mots-clés d'un jeu
export const getAllKeywordsForGame = (gameKey: AdvancedGameKey, language: KeywordLanguage = 'fr'): string[] => {
  const gameKeywords = ADVANCED_GAME_KEYWORDS[gameKey]?.[language];
  if (!gameKeywords) return [];
  
  return Object.values(gameKeywords).flat() as string[];
};

// Fonction pour obtenir une catégorie spécifique de mots-clés
export const getKeywordsByCategory = (
  gameKey: AdvancedGameKey, 
  category: KeywordCategory, 
  language: KeywordLanguage = 'fr'
): string[] => {
  const gameKeywords = ADVANCED_GAME_KEYWORDS[gameKey]?.[language];
  if (!gameKeywords || !gameKeywords[category as keyof typeof gameKeywords]) return [];
  
  return (gameKeywords[category as keyof typeof gameKeywords] as string[]) || [];
};

// Fonction pour générer une meta description optimisée
export const generateOptimizedMetaDescription = (
  gameKey: AdvancedGameKey, 
  language: KeywordLanguage = 'fr'
): string => {
  const primaryKeywords = getKeywordsByCategory(gameKey, 'primary', language);
  if (primaryKeywords.length === 0) return '';

  const templates = {
    fr: `Découvrez les meilleurs ${primaryKeywords[0]}s : classement serveurs, votes communauté, serveurs actifs vérifiés. Plus de 1000+ joueurs, rejoignez-nous !`,
    en: `Discover the best ${primaryKeywords[0]}s: rankings servers, community votes, verified active servers. Over 1000+ players, join us now!`,
    es: `Descubre los mejores ${primaryKeywords[0]}s: rankings servidores, votos comunidad, servidores activos verificados. ¡Más de 1000+ jugadores!`
  };

  return templates[language];
};

// Fonction pour générer un titre SEO optimisé
export const generateOptimizedTitle = (
  gameKey: AdvancedGameKey, 
  language: KeywordLanguage = 'fr'
): string => {
  const primaryKeywords = getKeywordsByCategory(gameKey, 'primary', language);
  if (primaryKeywords.length === 0) return '';

  const templates = {
    fr: `Top ${primaryKeywords[0].charAt(0).toUpperCase() + primaryKeywords[0].slice(1)}s ▶ Classement & Votes | RankServeur`,
    en: `Top ${primaryKeywords[0].charAt(0).toUpperCase() + primaryKeywords[0].slice(1)}s ▶ Rankings & Votes | RankServeur`,
    es: `Top ${primaryKeywords[0].charAt(0).toUpperCase() + primaryKeywords[0].slice(1)}s ▶ Rankings & Votos | RankServeur`
  };

  return templates[language];
};